let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gwML8")).then(() => parcelRequire('io7qH'));